<template>
  <b-button type="submit" v-bind="$attrs" @click="clicked" :class="{'disabled': this.submitting}">
    <slot></slot>
  </b-button>
</template>

<script>

export default {
  data() {
    return {
      submitting: false
    }
  },
  methods: {
    clicked(event) {
      if (this.submitting) {
        event.preventDefault()
        return
      }

      this.submitting = true

      this.$emit('click', event)

      setTimeout(() => {
        this.submitting = false
      }, 1444)
    }
  },
}
</script>
